import { SET_INCENTIVES } from '../actions/types';

export default function incentive(state = {}, action) {
	if (!action.error) {
		const incentives = action.payload;
		switch (action.type) {
			// case GET_INCENTIVES:
			// 	return {...state}  ;

			case SET_INCENTIVES:
				return incentives;

			default:
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/incentives.js